import { createBrowserRouter } from 'react-router-dom'
import { lazy, Suspense, type ComponentType } from 'react'
import Layout from '@/components/layout/Layout'

const Home         = lazy(() => import('@/pages/Home'))
const ChiSiamo     = lazy(() => import('@/pages/ChiSiamo'))
const Servizi      = lazy(() => import('@/pages/Servizi'))
const Eventi       = lazy(() => import('@/pages/Eventi'))
const EventoDetail = lazy(() => import('@/pages/EventoDetail'))
const Contatti     = lazy(() => import('@/pages/Contatti'))
const Safeguarding        = lazy(() => import('@/pages/safeguarding'))
const NotFound            = lazy(() => import('@/pages/NotFound'))
const Donazioni           = lazy(() => import('@/pages/Donazioni'))
const ContributiPubblici  = lazy(() => import('@/pages/ContributiPubblici'))

const withSuspense = (Component: ComponentType) => (
  <Suspense fallback={<div className="min-h-screen bg-board-dark" />}>
    <Component />
  </Suspense>
)

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true,          element: withSuspense(Home) },
      { path: 'chi-siamo',    element: withSuspense(ChiSiamo) },
      { path: 'servizi',      element: withSuspense(Servizi) },
      { path: 'eventi',       element: withSuspense(Eventi) },
      { path: 'eventi/:slug', element: withSuspense(EventoDetail) },
      { path: 'contatti',     element: withSuspense(Contatti) },
      { path: 'safeguarding',        element: withSuspense(Safeguarding) },
      { path: 'contributi-pubblici', element: withSuspense(ContributiPubblici) },
      { path: 'donazioni',           element: withSuspense(Donazioni) },
      { path: '*',            element: withSuspense(NotFound) },
    ],
  },
])